module.exports = __webpack_public_path__ + "static/img/SUP_PHOTO_AUTRE_01.3f00a67.jpg";